import React from "react";
import ApexCharts from "react-apexcharts";

const AreaChart = ({ data }) => {
  const roundToOneDecimal = (num) => Math.round(num * 10) / 10;
  const getTotalDurations = (arr) =>
    arr.map((item) => roundToOneDecimal(item.total_duration));

  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const weekDays = () => {
    if (data && Array.isArray(data) && data.length > 0) {
      const dates = data.map((item) => item?._id).filter(Boolean);
      console.log("dates", dates);

      const week_days = dates
        .map((dateStr) => {
          const date = new Date(dateStr);
          if (isNaN(date.getTime())) {
            console.warn(`Invalid date: ${dateStr}`);
            return null;
          }
          return daysOfWeek[date.getDay()];
        })
        .filter(Boolean);

      return week_days;
    } else {
      return [];
    }
  };

  const options = {
    chart: {
      type: "area",
      height: "100%", // Responsive height
      width: "100%", // Responsive width
      toolbar: {
        show: false, // Disable chart toolbar
      },
    },

    xaxis: {
      categories: weekDays(), // Weekdays

      axisTicks: {
        show: false, // Remove the ticks (the line that connects the labels)
      },
      labels: {
        show: false,
      },
    },
    yaxis: {
      max: 24,
     
      labels: {
        show: false, // Hide Y-axis labels
      },
    },
    stroke: {
      show: true, // Ensure the line is shown
      curve: "smooth", // Smooth the curve of the line
      width: 2, // Line width
      colors: ["#1270d4"], // Line color
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        gradientToColors: ["#1270d4"],
        shadeIntensity: 1,
        type: "horizontal",
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100, 100, 100],
      },
    },
    markers: {
      size: 2, // Size of the dots
      colors: ["#ffffff"], // Color of the dots
      strokeColors: "#4189ed", // Border color of the dots
      strokeWidth: 1, // Border width
      shape: "circle", // Shape of the marker
      hover: {
        size: 6, // Size of dots on hover
      },
    },
    tooltip: {
      show:false,
      shared: true,
      intersect: false,
      style: {
        fontSize: "12px", // Font size of tooltip
        color: "#ffffff", // White color for tooltip text
      },
    },
    dataLabels: {
      enabled: false, // Disable data labels on the chart
    },
    grid: {
      show: false, // Remove both horizontal and vertical grid lines
    },
    // Set background gridline and other styles for contrast
    plotOptions: {
      area: {
        fillTo: "origin", // Fill the chart till the bottom
      },
    },
  };

  const series = [
    {
      name: "Activity",
      data: getTotalDurations(data) || [], // Example attendance data for each weekday
    },
  ];

  return (
    <div
      className="area-chart"
      style={{
        width: "100%",
        height: "fit-content",
        padding: "0",
        margin: "0",
        boxSizing: "border-box",
      }}
    >
      <ApexCharts options={options} series={series} type="area" height="100%" />
    </div>
  );
};

export default AreaChart;
